import { render, staticRenderFns } from "./InventoryListSupplierAgent.vue?vue&type=template&id=476bf39c&"
import script from "./InventoryListSupplierAgent.vue?vue&type=script&lang=js&"
export * from "./InventoryListSupplierAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports